export default {
  fallbackLocale: ["en"],
};
